import React from "react";
import ReactECharts from 'echarts-for-react';
import PropTypes from 'prop-types';

const TreeChart = (props) => {
  const { bottom,
chartClick,
chartHeight,
chartWidth,
classn,
data,
events,
leavesConfig,
left,
optionPropsFunction,
right,
toolTipConfig,
top } = props;

  const getTreeOption = () => {
    const options = {
      tooltip: toolTipConfig ? { ...toolTipConfig } : {
        show: true,
        trigger: 'item',
        triggerOn: 'mousemove',
        formatter: function(params) {
          var tooltipContent = '';
          var filteredArray = params.treeAncestors.filter((item) => item.name.trim() !== '');
          filteredArray.forEach(function(item) {
            tooltipContent += item.name + '<br>';
          });
          return tooltipContent;
        }
        
      },
      series: [
        {
          type: 'tree',
          data: [data],
          top: top ? top : '1%',
          left: left ? left : '7%',
          bottom: bottom ? bottom : '1%',
          right: right ? right : '14%',
          symbolSize: 2,
          // edgeShape: 'polyline',
          // edgeForkPosition: '90%',
          orient: 'LR',
          label: {
            position: [5, 2],
            verticalAlign: 'middle',
            align: 'center',
            backgroundColor: '#ffffff',
            borderColor: '#ffffff', // Set border color to red
             borderWidth: 4, // Optional: Set border width
             borderRadius:5,
            // padding: [5, 5, 5, 5],
            color: node => node.data.label.color || 'black'
          },
          leaves: {
            label: {
              position: 'right',
              verticalAlign: 'middle',
              align: 'left',
              ...leavesConfig
            }
          },
          emphasis: {
            focus: 'ancestor',
            lineStyle: {
              width: 0.5,
              color: '#333'
            },
          },
          expandAndCollapse: false,
          animationDuration: 550,
          animationDurationUpdate: 750
        }
      ]
    };
    optionPropsFunction;
    return options;
  };

  const handleChartClick = (params) => {
    chartClick(params);
  };

  const onEvents = {
    'click': handleChartClick, //chart click event
  };
  return (
    <div style={{ height: `${chartHeight}px`, width: `${chartWidth}px` }} className={classn}>
      <ReactECharts option={getTreeOption()} onEvents={events ? onEvents : ""} style={{ height: `${chartHeight}px`, }}/>
    </div>
  );
};

TreeChart.propTypes = {
  bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  chartClick: PropTypes.func.isRequired,
  chartHeight: PropTypes.number.isRequired,
  chartWidth: PropTypes.number.isRequired,
  classn: PropTypes.string,
  data: PropTypes.object.isRequired,
  events: PropTypes.bool,
  leavesConfig: PropTypes.object,
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  optionPropsFunction: PropTypes.func,
  right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  toolTipConfig: PropTypes.object,
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TreeChart;



